import PropTypes from "prop-types";
import React from "react";

import { populateFormat, breakFormat } from "@togglecorp/fujs";
import styles from "./styles.module.scss";

const propTypes = {
  className: PropTypes.string,

  /**
   * Timestamp
   */
  date: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  /**
   * Options
   */
  mode: PropTypes.string,

  emptyComponent: PropTypes.func,
};

const defaultProps = {
  className: "",
  date: undefined,
  mode: "dd-MM-yyyy",

  emptyComponent: () => "-",
};

/**
 * Show timestamp in Human Readable Format
 */
export default class FormattedDate extends React.PureComponent {
  static propTypes = propTypes;

  static defaultProps = defaultProps;

  static getDate = (value) => {
    if (typeof value === "string") {
      const match = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
      if (match) {
        const [, year, month, day] = match;
        return new Date(Number(year), Number(month) - 1, Number(day));
      }
    }

    return new Date(value);
  };

  static formatDate = (date, mode) =>
    populateFormat(breakFormat(mode), date).map((e, i) => {
      const key = String(i);
      if (e.type === "date") {
        return (
          <span className="date" key={key}>
            {e.value}
          </span>
        );
      }
      if (e.type === "time") {
        return (
          <span className="time" key={key}>
            {e.value}
          </span>
        );
      }
      return (
        <span className="separator" key={key}>
          {e.value}
        </span>
      );
    });

  render() {
    const { date, mode, className, emptyComponent: Empty } = this.props;

    const containerClassName = [
      className,
      "formatted-date",
      styles.formattedDate,
    ].join(" ");

    if (!date) {
      return <div className={containerClassName}>{Empty && <Empty />}</div>;
    }

    const parsedDate = FormattedDate.getDate(date);
    if (Number.isNaN(parsedDate.getTime())) {
      return <div className={containerClassName}>{Empty && <Empty />}</div>;
    }

    const children = FormattedDate.formatDate(parsedDate, mode);
    return <time className={containerClassName}>{children}</time>;
  }
}
